import { Stack, CardMedia, Box } from "@mui/material";
import i18n from "localization/i18n";

import logo from "/images/SignLogo.svg";
import shape from "/images/Shapes.svg";
import illustration from "/images/illustration & font.svg";

export default function AuthLeftPanel() {
  return (
    <Box
      sx={{
        backgroundImage: "url('/images/BG.svg')",
        backgroundSize: "cover",
        backgroundAttachment: "fixed",
        position: "relative",
        height: "100%",
      }}
    >
      <Stack
        sx={{
          position: "relative",
          height: "100%",
          width: "50%"
        }}>
        <Stack
          sx={{
            position: "fixed",
            height: "100%",
            width: "50%"
          }}>
          <CardMedia
            component="img"
            image={logo}
            sx={{
              width: "8vw",
              top: "3%",
              left: "3%",
              position: "absolute",
              objectFit: "contain",
            }}
          />

          <CardMedia
            component="img"
            image={shape}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              width: "23vw",
              transform: i18n.language === "ar" ? "scaleX(-1)" : undefined,
            }}
          />

          <CardMedia
            component="img"
            image={illustration}
            sx={{
              top: "23%",
              position: "absolute",
              objectFit: "cover",
            }}
          />
        </Stack>
      </Stack>
    </Box>
  );
}